import { SpecializationSettingsModal } from "./SpecializationSettingsModal";

export default SpecializationSettingsModal;
